import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=795951d4&class=main-wrapper%20light-theme&style=padding%3A%200px%3B%20padding-bottom%3A%2020px&"
import script from "./Profile.vue?vue&type=script&lang=ts&"
export * from "./Profile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports